import axiosInstance from "services/AxiosInstance";

export const deleteBuyspaceService = async (apiArgs: { buyspaceId: string }): Promise<void> => {
  await axiosInstance.delete(`buyspace/${apiArgs.buyspaceId}`);
};
